import React, { Component } from 'react';
import { Col, Form, FormGroup, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL } from "../../Utils/Global";
import { getDateFromString } from "../../Utils/Date";

import Combobox from '../Helper/Combobox';
import FileUpload from '../Helper/FileUpload';
import Status from '../Helper/Status';

class ValeurImport extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
		super(props);

    this.state = {
      object: {},
      status: {},
      datasource: []
    };
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    let previewGrid = null;
    if(this.state.datasource.length > 0) {
      const options = {
        noDataText: 'Aucune donnée à afficher'
      };

      previewGrid = <BootstrapTable ref={"tablePreview"} data={this.state.datasource} options={options} height="400px" pagination striped hover>
        {this.getPreviewGridHeaders()}
      </BootstrapTable>
    }

    // Rendering the view
    return (
      <div>
        {/* Status information */}
        {status}

  			<Form horizontal onSubmit={this.handleSubmit.bind(this)}>
          <HelpBlock>Formulaire d'import de valeurs.</HelpBlock>

          {/* Form content */}

          {/* Observation OneToMany */}
          <FormGroup controlId="idObservation" validationState={this.getRequiredFieldValidationState("idObservation")} >
            <Col componentClass={ControlLabel} sm={2}>Observation</Col>
            <Col sm={6}><Combobox url={this.props.observationPath} optionValueKey="idObservation" optionLabelKey="titre"
              onChange={this.onObservationSelect.bind(this)} enableSearch={true}
              placeholder="Choisir une observation" /></Col>
          </FormGroup>

          <FormGroup controlId="file">
            <Col componentClass={ControlLabel} sm={2}>Fichier (CSV)</Col>
            <Col sm={6}>
              <FileUpload ref="file" mode={this.state.mode} onChange={this.onFileChange.bind(this)} onClear={this.onFileClear.bind(this)} accept={".csv"} />
            </Col>
          </FormGroup>

          {/* Submit button */}
          <FormGroup>
            <Col smOffset={7} sm={1}>
              <Button bsStyle="success" type="submit">Sauvegarder</Button>
            </Col>
          </FormGroup>
  			</Form>

        {previewGrid}

      </div>);
	}

  /**
  * handleSubmit
  * Catch the form submit and treat it
  **/
  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        type: 'info',
        message: 'Sauvegarde en cours...'
      }
    }, this.sendFormData);
  }

  /**
  * onFileChange
  * Catch the file field change
  **/
  onFileChange(fileField, file) {
    if(file) {
      const cutFile = file.name.split(".");
      if(cutFile[cutFile.length - 1] === "csv" || cutFile[cutFile.length - 1] === "CSV") {
        var reader = new FileReader();
        reader.onload = this.processCsv.bind(this);
        reader.onerror = function(event) {
          this.setState({
            status: {
              type: 'danger',
              message: 'Erreur de lecture du CSV.'
            }
          });
        }
        reader.readAsText(file, 'ISO-8859-1');
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Le fichier doit être un CSV.'
          }
        });
      }
    }
  }

  /**
  * onFileClear
  * Catch the file field clear
  **/
  onFileClear(fileField) {
    this.setState({
      datasource: []
    });
  }

  /**
  * processCsv
  * Process CSV file reading
  **/
  processCsv(event) {
    const csv = event.target.result;
    let data = csv.split(/\r\n|\n/);

    const headers = data.shift();
    const headersIdx = this.getCsvHeaders(headers.split(";"));
    if(headersIdx === false) return;
    const [titreIdx, stationIdx, dateIdx, valeurIdx, commentaireIdx] = headersIdx;
    let datasource = [];

    for (let i=0; i<data.length; i++) {
      const line = data[i].split(';');

      if(line.length > 1) {
        const cell = {
          titre: line[titreIdx],
          idStation: line[stationIdx],
          dateObservation: line[dateIdx],
          valeurObservation: line[valeurIdx],
          commentaire: line[commentaireIdx],
        };

        datasource.push(cell);
      }
    }

    this.setState({
      datasource: datasource
    });
  }

  /**
  * getCsvHeaders
  * Returns the CSV headers index
  **/
  getCsvHeaders(headers) {
    let titreIdx, stationIdx, dateIdx, valeurIdx, commentaireIdx;

    for(let cpt=0; cpt<headers.length; cpt++) {
      switch (headers[cpt]) {
        case "Titre":
          titreIdx = cpt;
          break;
        case "Station":
          stationIdx = cpt;
          break;
        case "Date":
          dateIdx = cpt;
          break;
        case "Valeur":
          valeurIdx = cpt;
          break;
        case "Commentaire":
          commentaireIdx = cpt;
          break;
        default:
          break;
      }
    }

    let message = false;

    if(titreIdx === undefined) message = 'Colonne "Titre" manquante.';
    if(stationIdx === undefined) message = 'Colonne "Titre" manquante.';
    if(dateIdx === undefined) message = 'Colonne "Titre" manquante.';
    if(valeurIdx === undefined) message = 'Colonne "Titre" manquante.';
    if(commentaireIdx === undefined) message = 'Colonne "Titre" manquante.';

    if(message !== false) {
      this.setState({
        status: {
          type: 'danger',
          message: message
        },
        datasource: []
      });

      return false;
    }

    return [titreIdx, stationIdx, dateIdx, valeurIdx, commentaireIdx];
  }

  /**
  * getPreviewGridHeaders
  * Returns the grid headers
  **/
  getPreviewGridHeaders() {
    const fields = [
      {nom: "titre", libelle: "Titre", isKey: true, empty: false},
      {nom: "idStation", libelle: "Station", empty: false},
      {nom: "dateObservation", libelle: "Date", isDate: true},
      {nom: "valeurObservation", libelle: "Valeur", empty: false},
      {nom: "commentaire", libelle: "Commentaire"}
    ];

    return fields.map(field => {
      let props = {
        key: field.nom,
        dataField: field.nom,
        isKey: field.isKey,
        dataSort: true
      };

      if(field.empty === false) {
         props.columnClassName = this.columnClassNameNonEmpty;
      }

      if(field.isDate === true) {
         props.columnClassName = this.columnClassNameDateFormat;
      }

      return <TableHeaderColumn {...props}>{field.libelle}</TableHeaderColumn>;
    });
  }

  /**
  * columnClassNameNonEmpty
  * Returns the cell class according to its value
  **/
  columnClassNameNonEmpty(fieldValue, row, rowIdx, colIdx) {
    return (fieldValue !== undefined && fieldValue !== "") ? '' : 'td-error-empty';
  }

  /**
  * columnClassNameDateFormat
  * Returns the cell class according to its value
  **/
  columnClassNameDateFormat(fieldValue, row, rowIdx, colIdx) {
    const dateValue = getDateFromString(fieldValue);
    return (!fieldValue || dateValue instanceof Date) ? '' : 'td-error-date';
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let state = this.state;

    // Validation des champs obligatoires
    if(this.getRequiredFieldValidationState("idObservation") === "error") {
      state.status = {
        type: 'danger',
        message: 'Choisir une observation dans la liste.'
      };
      this.setState(state);
      return;
    }

    const datasource = this.getValidDatasource();
    if(datasource === 0) {
      state.status = {
        type: 'danger',
        message: 'Aucune valeur à ajouter.'
      };
      this.setState(state);
      return;
    }

    const method = "POST";
    const path = REST_API_URL + "observations/" + this.state.object.idObservation + "/valeurs/";

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(datasource),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 201) {
        const valeurs = JSON.parse(response.entity);
        this.setState({
          status: {
            type: 'success',
            message: valeurs.length + ' valeurs d\'observation créées.'
          },
          datasource: []
        });

        this.refs["file"].onClearClick();

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          },
          datasource: []
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        },
        datasource: []
      });
		});
  }

  /**
  * getRequiredFieldValidationState
  * Returns the validation state for a required field
  **/
  getRequiredFieldValidationState(fieldName) {
    const value = this.state.object[fieldName];
    return (!value || value === undefined) ? "error" : null;
  }

  /**
  * onObservationSelect
  * Modify the state idObservation property from idObservation Combobox change
  **/
  onObservationSelect(observation) {
    let objState = this.state;
    objState.object["idObservation"] = (observation) ? observation.idObservation : null;
    this.setState(objState);
  }

  /**
  * getValidDatasource
  * Returns the datasource with only valid Valeur
  **/
  getValidDatasource() {
    const datasource = this.state.datasource;
    let validDatasource = [];

    for(let i=0; i<datasource.length; i++) {
      const valeur = datasource[i];

      if(this.columnClassNameNonEmpty(valeur.titre) === ""
      && this.columnClassNameNonEmpty(valeur.idStation) === ""
      && this.columnClassNameDateFormat(valeur.dateObservation) === "") {
        validDatasource.push(valeur);
      }
    }

    return validDatasource;
  }

}

export default ValeurImport;



// WEBPACK FOOTER //
// ./src/views/Entity/ValeurImport.js